<template>
	<div>
		<div class="row">
			<section class="col-md-9">
				<h2> Consulting Services </h2>
				<p>
				We have expertise and experience in various areas of computing.  If you are looking for an affordable 
				team to help bring your concept to reality, then we can help you.</p>
				<p>
				Currently we offer:
				<ul>
					<li> Custom software development&mdash; Websites, mobile apps, and desktop applications. </li>
					<li> Subject matter experts in Amazon Web Services, Android, iPhone, machine learning, 3D graphics, visualization, and mathematical programming.</li>
				</ul>
				</p>
				<p> For pricing and more information, please request a free consultation.</p>

				<h2> Our Web Applications </h2>
				<p></p>
				<div class="row">
					<div class="col-auto">
						<img src="/img/portfolio/advancegps.jpg" class="img-fluid" alt="">
						<!--
						<img src="//placehold.it/390" class="img-fluid" alt="">
						-->
					</div>
					<div class="col-auto">
						<img src="/img/portfolio/rallyflorida.org.jpg" class="img-fluid" alt="">
					</div>
				</div>
				<br>
				<div class="row">
					<div class="col-auto">
						<img src="/img/portfolio/tribusoft.com.jpg" class="img-fluid" alt="">
					</div>
					<div class="col-auto">
						<img src="/img/portfolio/iron-warriors.com.jpg" class="img-fluid" alt="">
					</div>
				</div>
				<br>
				<div class="row">
					<div class="col-auto">
						<img src="/img/portfolio/hfc.jpg" class="img-fluid" alt="">
					</div>
					<div class="col-auto">
						<img src="/img/portfolio/pink-chandelier.jpg" class="img-fluid" alt="">
					</div>
				</div>
				<br>

				<h2> Our Mobile Apps </h2>
				<p></p>
				<div class="row">
					<div class="col-auto">
						<img src="/img/portfolio/financial-advisor-1.jpg" class="img-fluid" alt="">
					</div>
					<div class="col-auto">
						<img src="/img/portfolio/financial-advisor-2.jpg" class="img-fluid" alt="">
					</div>
					<div class="col-auto">
						<img src="/img/portfolio/financial-advisor-3.jpg" class="img-fluid" alt="">
					</div>
				</div>
			</section>
			<section class="col-md-3">
				<div id="consultation-form">
					<h3> Get a Free Consultation! </h3>
					<div v-if="messageSent">
						<div class="alert alert-success" role="alert">
							Request was received! We will be contacting you soon.
						</div>
					</div>
					<div class="form-group">
						<label for="email">Your Email</label>
						<input type="email" class="form-control" id="email" aria-describedby="emailHelp" v-model="email">
						<small id="emailHelp" class="form-text text-muted">This is the email that we will follow-up with.</small>
					</div>
					<div class="form-group">
						<label for="phone">Your Phone</label>
						<input type="tel" class="form-control" id="phone" aria-describedby="phoneHelp" v-model="phone">
						<small id="phoneHelp" class="form-text text-muted">This is the phone number that we will follow-up with.</small>
					</div>
					<div class="form-group">
						<label for="description">Project Description</label>
						<textarea class="form-control" id="description" v-model="description">
						</textarea>
					</div>
					<button type="submit" class="btn btn-primary" @click="requestConsultation($event)">Submit</button>
				</div>
			</section>
		</div>
	</div>
</template>
<script>
export default {
	name: 'consulting',
	data: function() {
		return {
			email: '',
			phone: '',
			description: '',
			messageSent: false,
		}
	},
	methods: {
		requestConsultation: async function($evt) {
			$evt.preventDefault()

			const getUrl = window.location
			const baseUrl = getUrl .protocol + "//" + getUrl.host + "/"

			const response = await fetch(baseUrl + 'api/request-consultation', {
				method: 'POST',
				headers: new Headers({
					'Content-Type': 'application/json',
					'Accept': 'application/json',
				}),
				body: JSON.stringify({
					email: this.email,
					phone: this.phone,
					description: this.description,
				}) // body data type must match "Content-Type" header
			});

			if (response.ok) {
				this.messageSent = true
			}

		},
	},
}

</script>
<style>

label {
	font-family: 'Oswald', sans-serif;
	color: #5a99a6;
	font-weight: bold;
}
</style>
